export default __webpack_public_path__ + "static/media/recrute-cosmonaute.40410871.png";